import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ClassForm } from "./ClassForm";
import { EnrolledUsersModal } from "./EnrolledUsersModal";

interface ClassDialogsProps {
  editingId: string | null;
  selectedClassId: string | null;
  isCreating: boolean;
  classes: any[];
  selectedGymId: string | null;
  onCloseEdit: () => void;
  onCloseCreate: (value: boolean) => void;
  onCloseSelected: () => void;
  onSubmit: (formData: any) => Promise<boolean>;
}

export const ClassDialogs = ({
  editingId,
  selectedClassId,
  isCreating,
  classes,
  selectedGymId,
  onCloseEdit,
  onCloseCreate,
  onCloseSelected,
  onSubmit,
}: ClassDialogsProps) => {
  const editingClass = editingId ? classes?.find((c) => c.id === editingId) : undefined;

  console.log("🔍 ClassDialogs - Editing class:", {
    editingId,
    editingClass,
    gymId: editingClass?.gym_id,
    classesCount: classes?.length
  });

  return (
    <>
      <Dialog open={!!editingId} onOpenChange={(open) => !open && onCloseEdit()}>
        <DialogContent className="max-w-[calc(100%-2rem)] sm:max-w-lg max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Editar Clase</DialogTitle>
          </DialogHeader>
          <ClassForm
            onSubmit={onSubmit}
            initialData={editingClass}
            gymId={editingClass?.gym_id || selectedGymId}
            isEditing={true}
          />
        </DialogContent>
      </Dialog>

      <Dialog open={isCreating} onOpenChange={onCloseCreate}>
        <DialogContent className="max-w-[calc(100%-2rem)] sm:max-w-lg max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Crear Nueva Clase</DialogTitle>
          </DialogHeader>
          <ClassForm onSubmit={onSubmit} gymId={selectedGymId} />
        </DialogContent>
      </Dialog>

      <EnrolledUsersModal
        classId={selectedClassId}
        isOpen={!!selectedClassId}
        onClose={onCloseSelected}
      />
    </>
  );
};